import apiPath from "../config/api-path";
import httpRequest from "../config/http-api";

export default {
  getTaskList({ success, error }) {
    const {
      module: { list },
    } = apiPath;
    return httpRequest.getRequest(list, success, error);
  },

  getTaskByModuleById(id, { success, error }) {
    const {
      task: { getByModuleId },
    } = apiPath;
    return httpRequest.getRequest(getByModuleId(id), success, error);
  },

  createTask(data, { success, error }) {
    const {
      task: { create },
    } = apiPath;
    return httpRequest.postRequest(create, data, success, error);
  },
  updateTask(data, { success, error }) {
    const {
      task: { update },
    } = apiPath;
    return httpRequest.putRequest(update, data, success, error);
  },
};
